import {
  AuthFlowType,
  B2BProducts,
  type StytchB2BUIConfig,
} from "@stytch/vanilla-js";
import { AUTH_CONFIG } from "../config";

export const makeStytchB2BConfig = (
  authenticateUrl: string,
): StytchB2BUIConfig => ({
  authFlowType: AuthFlowType.Discovery,
  products: [B2BProducts.oauth, B2BProducts.sso, B2BProducts.emailMagicLinks],
  oauthOptions: {
    providers: [{ type: "google" }, { type: "github" }],
    loginRedirectURL: authenticateUrl,
    signupRedirectURL: authenticateUrl,
    discoveryRedirectURL: authenticateUrl,
  },
  emailMagicLinksOptions: {
    loginRedirectURL: authenticateUrl,
    signupRedirectURL: authenticateUrl,
    discoveryRedirectURL: authenticateUrl,
  },
  ssoOptions: {
    loginRedirectURL: authenticateUrl,
    signupRedirectURL: authenticateUrl,
  },
  directLoginForSingleMembership: {
    ignoreInvites: false,
    ignoreJitProvisioning: false,
    status: true,
  },
  sessionOptions: {
    sessionDurationMinutes: AUTH_CONFIG.sessionDurationMinutes,
  },
});

export const makeStytchB2BConfigIframe = (
  authenticateUrl: string,
): StytchB2BUIConfig => ({
  authFlowType: AuthFlowType.Discovery,
  products: [B2BProducts.oauth, B2BProducts.emailMagicLinks],
  oauthOptions: {
    providers: [{ type: "google" }],
    loginRedirectURL: authenticateUrl,
    signupRedirectURL: authenticateUrl,
    discoveryRedirectURL: authenticateUrl,
  },
  emailMagicLinksOptions: {
    loginRedirectURL: authenticateUrl,
    signupRedirectURL: authenticateUrl,
    discoveryRedirectURL: authenticateUrl,
  },
  directLoginForSingleMembership: {
    ignoreInvites: false,
    ignoreJitProvisioning: false,
    status: true,
  },
  sessionOptions: {
    sessionDurationMinutes: AUTH_CONFIG.sessionDurationMinutes,
  },
});
